import ChartBarIcon from '@heroicons/react/24/solid/ChartBarIcon';
import CogIcon from '@heroicons/react/24/solid/CogIcon';
import UserIcon from '@heroicons/react/24/solid/UserIcon';
import ChatIcon from '@heroicons/react/24/solid/ChatBubbleLeftEllipsisIcon';
import AdjustmentVertical from '@heroicons/react/24/solid/AdjustmentsVerticalIcon';
import DeviceIcon from '@heroicons/react/24/solid/DevicePhoneMobileIcon';
import { SvgIcon } from '@mui/material';

interface SideNavItem {
  title: string;
  path: string;
  icon: JSX.Element;
  badge?: string;
}

export const items: SideNavItem[] = [
  {
    title: 'Overview',
    path: '/',
    icon: (
      <SvgIcon fontSize='small'>
        <ChartBarIcon />
      </SvgIcon>
    ),
  },
  {
    title: 'Collections',
    path: '/collections',
    icon: (
      <SvgIcon fontSize='small'>
        <AdjustmentVertical />
      </SvgIcon>
    ),
  },
  {
    title: 'Devices',
    path: '/devices',
    icon: (
      <SvgIcon fontSize='small'>
        <DeviceIcon />
      </SvgIcon>
    ),
  },
  {
    title: 'Chat',
    path: '/chat',
    icon: (
      <SvgIcon fontSize='small'>
        <ChatIcon />
      </SvgIcon>
    ),
    badge: 'Beta',
  },
  {
    title: 'Account',
    path: '/account',
    icon: (
      <SvgIcon fontSize='small'>
        <UserIcon />
      </SvgIcon>
    ),
  },
  {
    title: 'Settings',
    path: '/settings',
    icon: (
      <SvgIcon fontSize='small'>
        <CogIcon />
      </SvgIcon>
    ),
  },
];
